// src/app/guards/logout.guard.ts
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}
  
  canActivate() {
    console.log('LogoutGuard activated');
    this.authService.logout();
    return false;
  }
}